import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { useWidthContext } from '../../providers/Width';
import './ProgressBar.css';
import { PathUtils } from '@adobe/aem-spa-page-model-manager';

interface IProgressBarProps extends MappedComponentProperties {
    stepNumber?: number;
    progressBarContentFragment?: IProgressBarContentFrag;
}

interface IProgressBarContentFrag {
    firstNodeTitle?: string;
    mobileText?: string;
    secondNodeTitle?: string;
    thirdNodeTitle?: string;

    firstNodeSubtitle?: string;
    secondNodeSubTitle?: string;
    thirdNodeSubtitle?: string;

    flow?: string
}

export const ProgressBarEditConfig = {
    emptyLabel: 'Progress Bar',
    isEmpty: (props: PropsWithChildren<IProgressBarProps>) => {
        return !props || !props.stepNumber;
    },
};

const ProgressBar = (props: PropsWithChildren<IProgressBarProps>): JSX.Element => {
    const containers = document.querySelectorAll('.ProgressBar__stepBubble') as NodeList;
    const activeNode = props.stepNumber ? props.stepNumber : 1;
    const lastNode = props.progressBarContentFragment?.thirdNodeTitle ? 3 : 2;
    const { width } = useWidthContext();

    const sourceIdAuthored = JSON.parse(PathUtils.getMetaPropertyValue('sourceIdOverrides') || '{}');
    
    const mobileOverride = (width < 600 && window.location.pathname.includes('/pre-approved/data-entry') && sourceIdAuthored.progressBarOverride ) ? true : false;

    for (let i = 0; i < containers.length; i++) {
        const container = containers[i] as HTMLDivElement;
        updateBarWidth(lastNode, container);
    }

    function updateBarWidth(count: number, container: HTMLDivElement) {
        const screenWidth = Math.min(width - 20, 868);
        const barWidth = screenWidth / count - 30 - 6;
        if (container !== null) {
            container.style.setProperty('--bar-width', barWidth + 'px');
        }
    }

    return (<div id='progress-bar' className={`ProgressBar ${mobileOverride ? 'ProgressBar__override' : ' '}`}>
        <div className={'ProgressBar__container--grid'}>
            <div className={`${mobileOverride ? 'ProgressBar_stepOneContainer' : ''}`}>
                <div className={`ProgressBar__stepBubble 
                ${activeNode >= 1 ? ' ProgressBar__progressStep' : ''}
                ${mobileOverride ? ' ProgressBar__stepBubble--bubbleOverride' : ''}`}>1
                </div>
                <div className={`ProgressBar__step--textContainer ProgressBar__content--bold 
                ${lastNode === 2 || activeNode === 1 ? ' ' : 'ProgressBar__container--hideOnMobile '}
                ${mobileOverride ? 'ProgressBar__step--mobileTextOverride' : ''}`}>
                    {!mobileOverride ? 
                    props.progressBarContentFragment?.firstNodeTitle : props.progressBarContentFragment?.mobileText 
                    }
                    <div className={'ProgressBar__subContent'}>
                        {props.progressBarContentFragment?.firstNodeSubtitle}</div>
                </div>
            </div>
            { !mobileOverride &&
            <div>
                <div className={`ProgressBar__stepBubble ' 
                        ${activeNode >= 2 ? 'ProgressBar__progressStep ' : ''}
                        ${lastNode === 2 && !mobileOverride ? 'ProgressBar__stepBubble--last ' : ''}
                        ${mobileOverride? 'ProgressBar__stepBubble--bubbleOverride' : ''}
                `}>{ !mobileOverride? 2 : ' ' }
                </div>
                <div className={`ProgressBar__step--textContainer ProgressBar__content--bold
                        ${ mobileOverride? 'ProgressBar__content--bold--override' : ''} 
                        ${lastNode === 2 || activeNode === 2 ? ' ' : 'ProgressBar__container--hideOnMobile '} `}>
                    {props.progressBarContentFragment?.secondNodeTitle}
                    <div className={'ProgressBar__subContent '}>
                        {props.progressBarContentFragment?.secondNodeSubTitle}
                    </div>
                </div>
            </div>
            }

            { !mobileOverride &&
            <div className={lastNode === 3 ? '' : 'ProgressBar__hide '}>
                <div className={`ProgressBar__stepBubble ' 
                        ${activeNode >= 3 ? 'ProgressBar__progressStep ' : ''}
                        ${lastNode === 3 && !mobileOverride ? 'ProgressBar__stepBubble--last ' : ''}
                        ${mobileOverride? 'ProgressBar__stepBubble--bubbleOverride' : ''}
                `}> { !mobileOverride ? 3 : ' ' }
                </div>
                <div className={`ProgressBar__step--textContainer ProgressBar__content--bold  
                        ${activeNode === 3 ?  ' ' : 'ProgressBar__container--hideOnMobile ' }`}>
                    {props.progressBarContentFragment?.thirdNodeTitle}
                    <div className={'ProgressBar__subContent'}>
                        {props.progressBarContentFragment?.thirdNodeSubtitle}
                    </div>
                </div>
            </div>
            }
        </div>
    </div>);
};

export default ProgressBar;